import { ReportListModel } from '@/models/report/report.model';
import { ApiErrorResponse } from '@/models/api/api-error.model';
import { defineStore, storeToRefs } from 'pinia';
import { api } from '@/services/http.service';
import { ElNotification } from 'element-plus';
import { useMgaReportListFilterStore } from '@/store/mga-reports/mga-report-list-filter.store';

type MgaReportListState = {
  reportList: ReportListModel | null;
  isReportListLoading: boolean;
};

export const useMgaReportListStore = defineStore({
  id: 'MgaReportListStore',
  state: (): MgaReportListState => ({
    reportList: null,
    isReportListLoading: false,
  }),
  actions: {
    setReportListLoading(loading: boolean): void {
      this.isReportListLoading = loading;
    },
    async getReportList(): Promise<void> {
      this.setReportListLoading(true);

      const { filterFormData } = storeToRefs(useMgaReportListFilterStore());

      api.report.getReportListRequest.perform(filterFormData.value).then((response) => {
        this.reportList = response;
      }).catch((error: unknown) => {
        const apiError = error as ApiErrorResponse;
        ElNotification({
          title: 'Error',
          message: apiError.response.data.message,
          type: 'error',
        });
      }).finally(() => {
        this.setReportListLoading(false);
      });
    },
  },
});
